import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.scss']
})
export class SolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  solutions = [
    {
      title: 'Gestão de Entrada de Seminovos',
      description: 'Para quem busca mais assertividade na precificação e rentabilidade nas negociações. Sem fórmulas prontas, a Union proporciona a gestão que vai reduzir os riscos e promover aumento do faturamento da sua concessionária.',
      imgSrc: './assets/svg-solutions/gestao.svg',
      link: '/solucao/gestao-de-entrada-de-seminovos/',
      imgAlt: 'Gestão'
    },
    {
      title: 'Consulta Veicular',
      description: 'Esqueça os pacotes "prontos"! Na Union você personaliza as informações de acordo com as necessidades específicas da sua empresa e paga apenas por isso. É hora de tomar a decisão certa.',
      imgSrc: 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/consultas.png',
      link: '/solucao/consulta-veicular/',
      imgAlt: 'Consulta Veicular'
    },
    {
      title: 'Decisão Certa',
      description: 'Negociações mais assertivas com a ferramenta mais confiável e atualizada do mercado. São mais de 160 itens de verificação personalizáveis de acordo com as necessidades da sua empresa.',
      imgSrc: './assets/svg-solutions/decisao.svg',
      link: '/solucao/decisao-certa/',
      imgAlt: 'Solucao Img'
    },
    {
      title: 'Vistoria Cautelar',
      description: 'Dados mais assertivos para o seu negócio de forma personalizável. Selecione as informações de acordo com as necessidades específicas da sua empresa para tomar a melhor decisão.',
      imgSrc: './assets/svg-solutions/vistoria.svg',
      link: '/solucao/vistoria-cautelar/',
      imgAlt: 'Solucao Img'
    },
    {
      title: 'Vistoria Veicular',
      description: 'Vistorias completas para atender às necessidades específicas do seu negócio. Entregamos toda a qualidade e segurança em vistorias veiculares para o seu segmento.',
      imgSrc: './assets/svg-solutions/veicular.svg',
      link: '/solucao/vistoria-veicular/',
      imgAlt: 'Solucao Img'
    },
    {
      title: 'Vistoria Autônoma',
      description: 'Processos automatizados, vistoria mobile e gestão digital. A auto inspeção é realizada pelo usuário final via token, sem que precise de vistorias físicas. Um ambiente totalmente digital e prático para a sua empresa.',
      imgSrc: './assets/svg-solutions/autonoma.svg',
      link: '/solucao/vistoria-autonoma/',
      imgAlt: 'Solucao Img'
    },
    {
      title: 'Caneta de Avaliação de Pintura',
      description: 'Uma ferramenta prática e desenvolvida com exclusividade. Evite problemas nas negociações e dê um passo à frente garantindo a segurança e qualidade na avaliação de pinturas e reparos de lataria.',
      imgSrc: './assets/svg-solutions/caneta.svg',
      link: '/solucao/caneta-de-avaliacao-de-pintura-2/',
      imgAlt: 'Solucao Img'
    },
    {
      title: 'Consulta de Análise de Crédito',
      description: 'Confira a situação de fornecedores e clientes para tomar as decisões mais assertivas para o seu negócio. Consulta pelo CPF ou CNPJ na base de dados mais atualizada do mercado.',
      imgSrc: './assets/svg-solutions/credito.svg',
      link: '/solucao/consulta-de-analise-de-credito/',
      imgAlt: 'Solucao Img'
    },
    {
      title: 'Curso de Vistoria Cautelar',
      description: 'Capacitação técnica com simuladores realistas, avaliação objetiva e certificação digital para apoiar equipes que atuam com vistoria cautelar.',
      imgSrc: './assets/svg-solutions/vistoria.svg',
      link: '/solucao/universidade-do-carro/',
      imgAlt: 'Curso de Vistoria Cautelar'
    }
  ];

}
